import React from 'react';
import EmailVerificationRequired from './EmailVerificationRequired';

const AgentEmailVerificationRequired: React.FC = () => {
  return <EmailVerificationRequired />;
};

export default AgentEmailVerificationRequired;
